<script lang="ts">
  import { t } from "../helpers/translations";
  import { DateFilterType } from "../helpers/types";
  import { globalDatePickerStore } from "../stores/date-picker";
  import ButtonNew from "../components/buttons/ButtonNew.svelte";
  import GPDataGrid from "../components/invoices/GPDataGrid.svelte";
  import PageHeaderNew from "../components/headers/PageHeaderNew.svelte";
  import DatePickerPanel from "../components/date-picker/DatePickerPanel.svelte";
  import { CONTENT_PADDING_X } from "../components/invoices/constants";
  import { createModal } from "../components/modals/createModal";
  import { invoicesPageHeaderHeight } from "../components/invoices/stores/dimensions";
  import SalesImportModal from "../components/invoices/SalesImportModal.svelte";

  const dateRangeFilters = [
    DateFilterType.Past7Days,
    DateFilterType.Past14Days,
    DateFilterType.ThisMonth,
  ];

  const GP_PAGE_VERTICAL_PADDING = "28px";
  const GP_PAGE_VERTICAL_GAP = "20px";

  const { underlayAttrs, contentAttrs, open, triggerElement, ...modal } = createModal();
</script>

<div
  class="container"
  style:--content-px={CONTENT_PADDING_X}
  style:--page-vertical-gap={GP_PAGE_VERTICAL_GAP}
  style:--page-vertical-padding={GP_PAGE_VERTICAL_PADDING}
>
  <PageHeaderNew title={t("gp.header.title")} bind:height={$invoicesPageHeaderHeight}>
    <div class="left" slot="left-aligned">
      <DatePickerPanel
        {dateRangeFilters}
        datePickerStore={globalDatePickerStore}
        hideFilteringDate
      />
    </div>

    <div class="right" slot="right-aligned">
      <ButtonNew size="xs" on:click={modal.onOpen} bind:element={$triggerElement}>
        {t("gp.importSales.cta")}
      </ButtonNew>
    </div>
  </PageHeaderNew>

  <main>
    <GPDataGrid />
  </main>
</div>

<SalesImportModal
  contentAction={modal.content}
  contentAttrs={$contentAttrs}
  underlayAttrs={$underlayAttrs}
  open={$open}
/>

<style>
  .container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    background-color: white;
    height: 100vh;
    padding: var(--page-vertical-padding) var(--content-px);
  }

  main {
    height: 100%;
  }

  .left {
    display: flex;
  }

  .right {
    display: flex;
    gap: 4px;
  }
</style>
